import axios, { type InternalAxiosRequestConfig } from 'axios'

import { MACHPROTOCOL_API_URL } from '@src/configs/env'

const MOCK_PRICES_500 = false
const MOCK_ASSETS_500 = false

const machProtocolMockResponses = new Map<
    string,
    {
        status: number
        data?: any
        headers?: Record<string, string>
        statusText?: string
    }
>()

const setMachProtocolMockResponse = (
    url: string,
    method: string,
    response: {
        status: number
        data?: any
        headers?: Record<string, string>
        statusText?: string
    }
) => {
    const key = `${method.toUpperCase()} ${url}`
    machProtocolMockResponses.set(key, response)
}

// Conditionally set mock responses
if (MOCK_PRICES_500) {
    setMachProtocolMockResponse('/prices', 'GET', {
        status: 500,
        headers: { 'X-Error-Code': '500' },
        statusText: 'MOCKED Internal Server Error',
    })
}

if (MOCK_ASSETS_500) {
    setMachProtocolMockResponse('/assets', 'GET', {
        status: 500,
        headers: { 'X-Error-Code': '500' },
        statusText: 'MOCKED Internal Server Error',
    })
}

// MachProtocol API instance
export const machProtocolAPI = axios.create({
    baseURL: MACHPROTOCOL_API_URL,
})

// Interceptor that checks our mock map for a matching request
machProtocolAPI.interceptors.request.use(function (config: InternalAxiosRequestConfig) {
    const key = `${config.method?.toUpperCase()} ${config.url}`
    if (machProtocolMockResponses.has(key)) {
        const mockResponse = machProtocolMockResponses.get(key)
        if (mockResponse) {
            // Override the adapter to simulate the mocked response
            // eslint-disable-next-line
            config.adapter = async () => ({
                data: mockResponse.data,
                status: mockResponse.status,
                statusText: mockResponse.statusText || (mockResponse.status === 200 ? 'OK' : 'Error'),
                headers: mockResponse.headers || {},
                config,
            })
        }
    }
    return config
})
